export default "__VITE_ASSET__97b71573__"